import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
// import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';
import * as appointmentActions from '../../../actions/appointmentActions';
import * as constant from '../../../constants/constant';
// import VideoCall from './App';
import * as url from '../../../tools/config.js';
// import openSocket from 'socket.io-client';
import { ToastContainer, toast } from 'react-toastify';
import moment from 'moment';
// const socket = openSocket(url.getURLForServer(process.env.REACT_APP_NODE_ENV).SOCKET_URL);
import VideoSectionReceiver from './videoCallReceive';
import * as dashboardActions from "../../../actions/dashboardActions";
// import $ from "jquery";


class VideoSection extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			appointmentDetails: {},
			image: '',
			DOB: '',
			appointmentMode: '',
			videocall:false,
			doctorDetails:{},
			joinDiv : false,
			docQualification:'',
			docSpecialisation:'',
			docExp:''

		}
		this.reciveCall = this.reciveCall.bind(this);
		this.onclose = this.onclose.bind(this);

	}

	componentWillMount() {
		if (this.props.match.params.appointmentId) {
			let appointmentObj = {
				appointmentId: this.props.match.params.appointmentId
			}
			this.props.actions.getAppointmentDetails(appointmentObj);
		}

	}
	reciveCall() {
		if (this.props.match.params.videoId) {
			this.setState({
				joinDiv:true
			})
			let userData = JSON.parse(localStorage.getItem('user'))
			// let url = (userData.type == 'specialist' ? constant.VIDEO_CALL_URL + '/specialist/video-call-receive/' : constant.VIDEO_CALL_URL + '/video-call-receive/'
			// )
			this.setState({
				videocall :true
			})
			// window.open(url + this.props.match.params.videoId, 'specailist', 'toolbar=0,status=0,width=548,height=325');
			// window.open(url + this.props.match.params.videoId, "_blank");
			// browserHistory.push(url + this.props.match.params.videoId)
		
		}
	}
	componentWillReceiveProps(nextProps) {
	this.setState({ appointmentDetails: nextProps.appointmentDetails.patient ? nextProps.appointmentDetails.patient[0] : {},
			docExp:  nextProps.appointmentDetails ? nextProps.appointmentDetails.docExp :'',
			docQualification : nextProps.appointmentDetails ? nextProps.appointmentDetails.Docqualification :'',
			docSpecialisation :  nextProps.appointmentDetails ? nextProps.appointmentDetails.Docspecialization :'',
			doctorDetails:nextProps.appointmentDetails.users ?  nextProps.appointmentDetails.users[0]:{},
      image: nextProps.appointmentDetails.patientdet ? nextProps.appointmentDetails.patientdet[0].profileImage : '',
       DOB: nextProps.appointmentDetails.patientdet ? nextProps.appointmentDetails.patientdet[0].dateOfBirth : '', appointmentMode: nextProps.appointmentDetails ? nextProps.appointmentDetails.appointmentMode : '',
			doctorImage :  nextProps.appointmentDetails ? nextProps.appointmentDetails.profileImage : '',

		})

		}
onclose(){

	this.setState({
		videocall :false,
		joinDiv:false
	})
}
	render() {
    // debugger;
		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
        let image = this.state.image;
        let imagePath = '';
		var userType = localStorage.getItem('userType');
		var currentDate = moment(new Date(),'Europe/London')
		var defaultImagePath = userType == 'specialist' ?

			this.state.appointmentDetails.gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_m.png" :
			constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_f.png" :this.state.doctorDetails.gender == "Male" ? constant.PRODUCTION_IMAGE_URL + "uploads/common/doctor_m.png" :
      constant.PRODUCTION_IMAGE_URL + "uploads/common/doctor_f.png";
      if (user.image == constant.DEFAULT_USER_IMAGE) {
        imagePath = user.gender=='Male'? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER +constant.COMMON_FOLDER +'doctor_m.png': constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER +constant.COMMON_FOLDER +'doctor_f.png' ;
      } else {
        imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + localStorage.getItem('userId') + '/' + user.image;
      }
    //   var currentDate = moment(new Date(),'Europe/London')
      currentDate = moment(new Date(),'Europe/London')

    //   var userType = localStorage.getItem('userType');
      userType = localStorage.getItem('userType');

    //   var defaultImagePath = userType == 'specialist' ?
      defaultImagePath = userType == 'specialist' ?

        this.state.appointmentDetails.gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_m.png" :
        constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_f.png" :this.state.doctorDetails.gender == "Male" ? constant.PRODUCTION_IMAGE_URL + "uploads/common/doctor_m.png" :
        constant.PRODUCTION_IMAGE_URL + "uploads/common/doctor_f.png";
        var sidebartoggle = true;
        // var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
        user = JSON.parse(localStorage.getItem('user'))
        var condition = (((user.userName != undefined || user.gender != undefined )&& user.availabilityCount > 0 )&& user.isVerified == '2')

		return (
      <div>
      {userType== 'specialist'?
      <header className="main-header">
              <Link to={ "/specialist/my-appointment"} className="logo">						<span className="logo-mini"><img src={require('../../../images/img/logo_er_ms.png')} alt="" /></span>
                  <span className="logo-lg"><img src={require('../../../images/img/logo_er.png')} alt="" /></span> </Link>
                <nav className="navbar navbar-static-top" role="navigation">
                  <Link href="#" className="sidebar-toggle" data-toggle="push-menu" role="button" onClick={this.toggle}> <img src={require('../../../images/img/menu_list.svg')} alt="" /> <span className="sr-only">Toggle navigation</span> </Link>
                  <div className="navbar-custom-menu">
                    <ul className="nav navbar-nav">
                      <li onClick={this.onLogoutclick} className={this.state.logoutButton == true ? "dropdown user user-menu show" : "dropdown user user-menu"}>

                        <Link href="#" className="dropdown-toggle" data-toggle="dropdown">
                          <img src={imagePath} className="user-image" alt="User Image" onError={(e) => { e.target.src = defaultImagePath }} />
                          <span className="hidden-xs name-capitalize">{user.firstName ? user.firstName : ''} {user.lastName ? user.lastName : ''}</span> </Link>
                        <ul className={this.state.logoutButton === true ? "dropdown-menu popupdropdown show" : "dropdown-menu popupdropdown"}>

                          <li className="user-setting">	<Link to={{ pathname: "/specialist/my-settings", state: 1 }}>

                            <img
                              src={require('../../../images/Slicing/Settings-profile.png')}
                              className="user-image"
                              alt="User Image"
                              onError={e => {
                                e.target.src = defaultImagePath;
                              }}
                            />
                            <span>Settings</span>
                          </Link></li>
                          <li
                            className="user-footer passwordLink"
                          // style={{ textAlign: "center" }}
                          >

                            <Link

                              className="uploadLink"
                              onClick={this._logout}
                            >
                              <img
                                src={require('../../../images/Slicing/logout-profile.png')}
                                className="user-image"
                                alt="User Image"
                                onError={e => {
                                  e.target.src = defaultImagePath;
                                }}
                              />
                              <span>	Sign out</span>
                            </Link>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </nav>
              </header>
        :''
      }

			<ToastContainer />
			<div className={this.state.joinDiv  == true?"content-wrapper videoShowNone" : 'content-wrapper'}>
				<section className="content container-fluid">
					<div className="row">
						<div className="col-md-12">
							<div className="boxMrgB">
								<div className="nav-tabs-custom">
									<ul className={this.state.joinDiv == true ?"nav nav-tabs videonavshownone": "nav nav-tabs"}>
										<li ><Link href="#tab_1" data-toggle="tab" className="active show">Waiting Room</Link></li>
									</ul>
									<div className={this.state.joinDiv == true ? "tab-content tabVideoNone" : "tab-content"}>
                    <div className="tab-pane active" id="tab_1">
                    <div className={userType == 'specialist' ?"waiting-specialist" : "waiting-patient"}>

											<div className={this.state.joinDiv == true ? "settingInput settingV waitingDiv ":"settingInput settingV "}>
									{	user.type== "patient" ?		<div className="row">
													<div className="userProImg">
														{this.state.doctorImage == constant.DEFAULT_USER_IMAGE ? <img className="user-image" src={this.state.doctorDetails.gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + 'uploads/'+constant.COMMON_FOLDER + 'doctor_m.png' : constant.PRODUCTION_IMAGE_URL + 'uploads/'+constant.COMMON_FOLDER + 'doctor_f.png'} alt="User profile picture" onError={e => {
															e.target.src = defaultImagePath;
														}} /> : <img className="user-image" src={constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + this.state.doctorDetails._id + '/' + this.state.doctorImage} onError={e => {
															e.target.src = defaultImagePath;
														}} />}
													</div>
													<div className="col-7 text-left">
														<strong className="capitalize">Dr. {this.state.doctorDetails ? this.state.doctorDetails.userName : ''}</strong>
														<p>{this.state.doctorDetails && this.state.doctorDetails.gender ? this.state.doctorDetails.gender : ''}</p>
														<p>{this.state.docQualification ? this.state.docQualification : ''} | {this.state.docSpecialisation ? this.state.docSpecialisation : ''}</p>
														<p>Exp: {this.state.docExp ? currentDate.diff(this.state.docExp,'years') + ' Years':"" }  {this.state.docExp ? (currentDate.diff(this.state.docExp,'months') % 12) +' Months' :''}</p>

														<p>Mode:{this.state.appointmentMode == 2 ? 'Online' : ''}</p>

													</div>
													<div className="col-3">
														<p></p>
														<p>Waiting</p>
														<p style={{ cursor: 'pointer' }}><button style={{ 'padding': '5px', 'color': 'white' }} onClick={this.reciveCall} className="btn btn-primary btn-signup">Join Call</button></p>
													</div>
												</div>
											:
												<div className="row">
													<div className="userProImg">
                          {image == constant.DEFAULT_USER_IMAGE ? <img className="profile-user-img img-responsive img-circle" src={this.state.appointmentDetails.gender == "Male"?  constant.PRODUCTION_IMAGE_URL + 'uploads/'+ constant.COMMON_FOLDER + 'patient_m.png':constant.PRODUCTION_IMAGE_URL + 'uploads/'+ constant.COMMON_FOLDER + 'patient_f.png'} alt="User profile picture" onError={e => {
                            e.target.src = defaultImagePath;
                          }} /> : <img className="profile-user-img img-responsive img-circle" src={constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + this.state.appointmentDetails._id + '/' + image} onError={e => {
                            e.target.src = defaultImagePath;
                          }} />}
													</div>
													<div className="col-7 text-left">
														<strong className="capitalize">{this.state.appointmentDetails ? this.state.appointmentDetails.userName : ''}</strong>
														<p>{this.state.DOB ? moment(this.state.DOB).format('DD-MMM-YYYY') : ''}</p>
														<p>{this.state.DOB ? moment().diff(this.state.DOB, 'years') : ''}y/o. {this.state.appointmentDetails ? this.state.appointmentDetails.gender : ''}</p>
														<p>Mode:{this.state.appointmentMode == 2 ? 'Online' : ''}</p>
													</div>
													<div className="col-3">
														<p></p>
														<p>Waiting</p>
														<p style={{ cursor: 'pointer' }}><Link style={{ 'padding': '5px', 'color': 'white' }} onClick={this.reciveCall} className="btn btn-primary btn-signup">Join Call</Link></p>
													</div>
												</div>
									}

											</div>
											{this.state.videocall ? <VideoSectionReceiver onclose={this.onclose.bind(this)} videocall={this.state.videocall} videoId={this.props.match.params.videoId} /> : ''}
                    						</div>
                    					</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
			</div>
		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		sessionData: state.appointment.sessionData,
		appointmentDetails: state.appointment.appointmentDetails
	};
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(appointmentActions, dispatch),
		logoutAction: bindActionCreators(dashboardActions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(VideoSection);
